export const getCookieByName = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            try {
                var a = atob(c.substring(name.length, c.length));
                return JSON.parse(a);
            } catch (e) {
                console.error(`Error parsing cookie ${cname}:`, e);
                return false;
            }
        }
    }
    return false;
}

export const setCookieByName = (state, cname) => {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    var expires = "; path=/; expires=" + date.toGMTString();
    var cookie = `${cname}=${btoa(JSON.stringify(state))}${expires}`;
    document.cookie = cookie;
}

export const deleteAllCookies = () => {
    const cookies = ['d__ac', 'd__ly'];
    for (var cookie of cookies) {
        document.cookie = `${cookie}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/;`;
    }
}

export const langObject = () => {
    return ['es', 'ca', 'en', 'fr', 'pt', 'it', 'ES-es'];
}

export const setCookieLayout = (state) => {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    var expires = "; path=/; expires=" + date.toGMTString();
    var cookie = 'd__ly=' + JSON.stringify(state) + expires;
    document.cookie = cookie;
}

export const getCookieLayout = () => {
    var name = "d__ly=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            try {
                var res = c.substring(name.length, c.length);
                return JSON.parse(res);
            } catch (e) {
                return null;
            }
        }
    }
    return null;
}

export const idExist = (id, array) => {
    return array.some(item => item.id === id);
}

export const returnElementFromArray = (el, array, type) => {
    return array.find(item => item[type] === el) || null;
}